var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{'has-logo': _vm.showLogo}},[_c('logo',{attrs:{"collapse":_vm.isCollapse}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }